import './Button.scss';
import NP, {EventArgs} from "../../NP";
import Control from "../../Control";
import Menu from "../Menu/Menu";

export default class Button extends Control {

	_Attributes: { [key: string]: string; };
	_FontImage: string;
	_IsPressed: boolean;
	_Menu: Menu;

	_isMyMenu: boolean;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._Attributes = {};
		this._FontImage = null;
		this._IsPressed = null;
		this._Menu = null;
		super._initFields(settings);
	}

	getFontImage()
	{
		return this._FontImage;
	}

	getMenu()
	{
		return this._Menu;
	}

	getIsPressed()
	{
		return this._IsPressed;
	}

	setIsPressed(value: boolean)
	{
		this._IsPressed = value;
	}

	_render(tag: string = 'button')
	{
		let content = this._RK ? NP.RM.getString(this._RK) : this._Content;

		if (this._FontImage)
			this.np_render(`<${tag} class="app-button"><span class="app-button__icon ${this._FontImage}"></span>${content}</${tag}>`);
		else
			this.np_render(`<${tag} class="app-button">${content}</${tag}>`);

		Object.keys(this._Attributes).map(attr =>
		{
			if (Object.prototype.hasOwnProperty.call(this._Attributes, attr))
				this._root.setAttribute(attr, this._Attributes[attr]);
		});

		this._isMyMenu = false;
		if (this._Menu && !(this._Menu instanceof Menu))
		{
			this._Menu = new Menu(this._Menu);
			this._isMyMenu = true;
		}
	}

	_onClicked(sender: Button, args: EventArgs)
	{
		if (this._Enabled)
		{
			if (this._IsPressed !== null)
				this.setIsPressed(!this._IsPressed);

			if (this._Menu)
				NP.showDropPanel(this._Menu, this._root, NP.LTRB.Bottom);

			return super._onClicked(this, args);
		}
	}

	setMenu(value: Menu)
	{
		this._Menu = value;
	}

	setContent(value: string)
	{
		value = this._FontImage ? `<span class="app-button__icon ${this._FontImage}"></span>${value}` : value;
		this._setContentToNode(<any>value, this._root, "Content", true);
	}

	setFontImage(value: string)
	{
		let node = this._root.querySelector('.app-button__icon');
		NP.removeCssClass(node, this._FontImage);
		NP.addCssClass(node, value);
		this._FontImage = value;
	}

	destroy()
	{
		if (!this._isMyMenu)
			delete this._Menu;
		super.destroy();
	}
}